const API = process.env.NEXT_PUBLIC_API_BASE_URL ?? "http://localhost:8080";

import { getDeviceId } from "./device";

type QItem = { kind: "error" | "event"; payload: Record<string, unknown> };

const queue: QItem[] = [];
let flushing = false;

function push(item: QItem) {
	queue.push(item);
	if (typeof window !== "undefined") void flushNow();
}

async function flushNow() {
	if (flushing || queue.length === 0 || typeof window === "undefined") return;
	flushing = true;
	const items = queue.splice(0, queue.length);
	await Promise.all(items.map(sendOne));
	flushing = false;
}

async function sendOne(item: QItem) {
	const path = item.kind === "error" ? "/telemetry/error" : "/telemetry/event";
	const body = {
		...item.payload,
		device_id: getDeviceId(),
		page_url: window.location.pathname,
	};
	try {
		await fetch(`${API}${path}`, {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(body),
			keepalive: true,
		});
	} catch {
		/* telemetry 失败绝不破坏 UX */
	}
}

export function reportError(e: {
	message: string;
	stack?: string;
	source?: string;
	lineno?: number;
	colno?: number;
	severity?: string;
}) {
	push({ kind: "error", payload: e as Record<string, unknown> });
}

export function trackEvent(
	event: string,
	category: "funnel" | "payment",
	properties?: Record<string, unknown>,
) {
	push({
		kind: "event",
		payload: { event, category, properties: properties ?? null },
	});
}

// installErrorReporting 挂全局错误监听；幂等（重复调用无害）。
let errorReportingInstalled = false;
export function installErrorReporting() {
	if (typeof window === "undefined" || errorReportingInstalled) return;
	errorReportingInstalled = true;
	window.onerror = (msg, src, line, col, err) =>
		reportError({
			message: String(msg),
			stack: err?.stack,
			source: src as string,
			lineno: line,
			colno: col,
		});
	window.onunhandledrejection = (ev) => {
		const r = (ev as PromiseRejectionEvent).reason as
			| { message?: string; stack?: string }
			| undefined;
		reportError({ message: r?.message ?? String(ev), stack: r?.stack });
	};
	window.addEventListener("pagehide", () => void flushNow());
	document.addEventListener("visibilitychange", () => {
		if (document.visibilityState === "hidden") void flushNow();
	});
}
